import { ScannerHandlerBase } from './scanner-handler-base';
import { ScannerHandlerResolverService } from './scanner-handler-resolver.service';

export function ScannerHandler() {
  return function (target: typeof ScannerHandlerBase): void {
    if (!target.Key) {
      throw new Error(`ScannerHandler: Key must be provided in ${target.name}`);
    }

    ScannerHandlerResolverService.registerHandler(target.Key, target);
  };
}
